export default "__VITE_ASSET__DCQlQ$Mk__"